import { theme } from '@garnish/constants';

export const CUSTOM_NAVIGATION_HEADER_HEIGHT = 72;
export const CUSTOM_NAVIGATION_HEADER_HORIZONTAL_PADDING = theme.spacing['4'];
export const CUSTOM_NAVIGATION_HEADER_CONTENT_HORIZONTAL_PADDING = theme.spacing['4'];
export const CUSTOM_NAVIGATION_HEADER_BUTTON_SIZE = 40;
